import React from 'react'
import WishListDetails from './WishListDetails'

const WishListBody = () => {
  return (
    <div className="view-qualities folded router-view-container">
      <WishListDetails />
    </div>  
  )
}

export default WishListBody